import React from 'react';
import Paragraph from 'components/atoms/text/paragraph';
import { CommonOrganismProps } from '../../types';
import Section from '..';

interface Props extends CommonOrganismProps {
  description: string;
}

export default function SectionWithParagraph({ title, description, styles }: Props) {
  return (
    <Section title={title} styles={styles}>
      <Paragraph text={description} />
    </Section>
  );
}
